// extracted by mini-css-extract-plugin
export var formContainer = "_ij-0";
export var message = "_ij-1";